/**
 * Single source of truth for company facts. Schema, fact blocks and llms files
 * must agree with this, because search engines and LLMs lower confidence in
 * entities whose facts conflict between sources.
 */
export const SITE_URL = 'https://builderlync.com'

export const ORG_ID = `${SITE_URL}/#organization`
export const WEBSITE_ID = `${SITE_URL}/#website`
export const SOFTWARE_ID = `${SITE_URL}/#software`

export const SHARE_IMAGE = { url: '/opengraph-image', width: 1200, height: 630 }

export const COMPANY = {
  name: 'BuilderLync',
  legalName: 'BuilderLync Inc.',
  founded: '2024',
  launched: 'June 1, 2026',
  ceo: 'Brad Strawbridge',
  phone: '+1-866-251-3315',
  phoneDisplay: '(866) 251-3315',
  email: 'info@builderlync.com',
  address: {
    street: '6501 Arlington Expressway B105',
    city: 'Jacksonville',
    region: 'FL',
    postalCode: '32211',
    country: 'US',
  },
  plans: [
    { name: 'Starter', price: 497, summary: 'The full operations platform with unlimited users. No AI features or Storm Intelligence.' },
    { name: 'Pro', price: 997, summary: 'Everything in Starter plus Storm Intelligence and the full AI stack, with 10,000 AI credits and 500 AI voice minutes per month.' },
  ],
} as const
